import React, {Component} from 'react';
import {Col, Row, Typography, Alert} from "antd";
import AccompagnateurBloc from "./AccompagnateurBloc";
import {t} from '../../../constant/i18n';
const {Title, Text} = Typography;
class Accompagnateur extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <div className="centerTxt mb10 mt10">
                    <Title level={3}>{t('accompagnateur.withOthers')}</Title>

                </div>

                <Row>
                    <Col span={24}>
                        <Alert message={t('accompagnateur.individualApp')} type="info" />

                        <AccompagnateurBloc />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Accompagnateur;